<div class="map-navigation" [formGroup]="formGroup">
    <priva-filter-search
        class="map-navigation__search"
        [config]="filterSearchConfig"
        [dataSource]="rowsDataSource"
        data-test="search-row-bar"
    />

    <div class="map-navigation__map-selector" data-test="select-map">
        <ng-select
            priva-combobox
            class="greenhouse-selector"
            [items]="greenHouseMaps$ | async"
            formControlName="map"
            bindLabel="name"
            size="md"
            [clearable]="false"
            [searchable]="false"
        />
    </div>
</div>
